/* Softies - Find your perfect Softie quiz. No dependencies. */
(function () {
    "use strict";

    var FAMILIES = ["Bunny Bunch", "Bear Collective", "Wild Ones", "Sea Softies", "Fluffy Flock", "Ele Friends", "Dino Pals", "Pawfect Pups"];
    var COLOURS = { pink: "#F2B8C0", blue: "#9EC3DC", brown: "#8A6248", grey: "#B5B5B2", beige: "#E6D6BE", white: "#FFFFFF", green: "#9DB07A", red: "#C9473C", orange: "#E8935A", purple: "#B79BCF", yellow: "#F4D581", black: "#2E2A27" };
    var TYPES = ["Cuddly plush", "Giant plushie", "Baby comforter", "Water bottle", "Keyring"];
    var WHO = [
        { v: "baby", label: "New baby", sub: "0-3 years · comforters & first cuddles", c: "#F6C8C8", icon: "♡", types: ["Baby comforter", "Cuddly plush"] },
        { v: "little", label: "Little one", sub: "3-12 years", c: "#BABD8B", icon: "★", types: ["Cuddly plush", "Water bottle", "Giant plushie"] },
        { v: "teen", label: "Teen / grown-up", sub: "13+ or a treat for yourself", c: "#F4D581", icon: "☀", types: ["Keyring", "Water bottle", "Cuddly plush", "Giant plushie"] },
    ];
    var BUDGETS = [
        { v: "u10", label: "Under £10", sub: "Keyrings & little gifts", min: 0, max: 999 },
        { v: "10-20", label: "£10-£20", sub: "Most of the range", min: 1000, max: 2000 },
        { v: "20-40", label: "£20-£40", sub: "Big & special", min: 2000, max: 4000 },
        { v: "40", label: "Treat them", sub: "£40+ giants", min: 4000, max: Infinity },
    ];
    var MAX_PERS = 3;

    function esc(s) {
        return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
            return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
        });
    }
    function list(v) {
        if (v == null || v === "") return [];
        if (Array.isArray(v))
            return v
                .map(function (x) {
                    return String(x).trim();
                })
                .filter(Boolean);
        return String(v)
            .split(/[\n|,]+/)
            .map(function (x) {
                return x.trim();
            })
            .filter(Boolean);
    }
    function normColour(c) {
        c = c.toLowerCase().replace(/-\d+$/, "").trim();
        return c === "gray" ? "grey" : c;
    }
    function normFamily(f) {
        var l = f.toLowerCase();
        for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i].toLowerCase() === l) return FAMILIES[i];
        return f;
    }

    /* Product type: uses Shopify "Product type" when it matches one of TYPES, otherwise worked out from the name. */
    function productType(p) {
        var t = (p.type || "").trim();
        for (var i = 0; i < TYPES.length; i++) if (TYPES[i].toLowerCase() === t.toLowerCase()) return TYPES[i];
        var n = ((p.productTitle || "") + " " + (p.title || "")).toLowerCase();
        if (n.indexOf("bottle bag") > -1) return "Accessory";
        if (n.indexOf("bottle") > -1) return "Water bottle";
        if (n.indexOf("comforter") > -1) return "Baby comforter";
        if (n.indexOf("keyring") > -1 || n.indexOf("key ring") > -1) return "Keyring";
        if (n.indexOf("giant") > -1 || /\bbig\b/.test(n)) return "Giant plushie";
        return "Cuddly plush";
    }

    function prepare(raw) {
        return raw
            .filter(function (p) {
                return p && p.id;
            })
            .map(function (p) {
                return {
                    id: p.id,
                    title: p.title || p.productTitle,
                    subtitle: p.subtitle || "",
                    url: p.url,
                    price: Number(p.price) || 0,
                    image: p.image,
                    family: list(p.family).map(normFamily)[0] || "",
                    personality: list(p.personality),
                    colours: list(p.colours).map(normColour),
                    kind: productType(p),
                };
            });
    }

    /* Pure matching logic - exposed for testing as SoftiesQuiz.match */
    function match(products, a) {
        var who = WHO.filter(function (w) {
            return w.v === a.who;
        })[0];
        var budget = BUDGETS.filter(function (b) {
            return b.v === a.budget;
        })[0];
        var types = a.types && a.types.length && a.types.indexOf("any") === -1 ? a.types : null;
        var out = products
            .filter(function (p) {
                if (who && who.types.indexOf(p.kind) === -1) return false;
                if (types && types.indexOf(p.kind) === -1) return false;
                if (a.families.length && a.families.indexOf(p.family) === -1) return false;
                if (
                    a.colours.length &&
                    !p.colours.some(function (c) {
                        return a.colours.indexOf(c) > -1;
                    })
                )
                    return false;
                if (budget && (p.price < budget.min || p.price >= budget.max)) return false;
                return true;
            })
            .map(function (p) {
                var score = p.personality.filter(function (x) {
                    return a.personality.indexOf(x) > -1;
                }).length;
                return { p: p, score: score };
            });
        out.sort(function (x, y) {
            return y.score - x.score || x.p.price - y.p.price;
        });
        return out;
    }

    function init(root) {
        var dataEl = root.querySelector("[data-sq-products]");
        var stage = root.querySelector("[data-sq-stage]");
        var products = [];
        try {
            products = prepare(JSON.parse(dataEl.textContent));
        } catch (e) {
            stage.innerHTML = "<p>Sorry, the quiz could not load. Please refresh the page.</p>";
            return;
        }
        var currency = root.getAttribute("data-currency") || "GBP";
        var clubUrl = root.getAttribute("data-club-url") || "/pages/softies-club";
        var perPage = parseInt(root.getAttribute("data-results"), 10) || 6;
        var fmt = function (pence) {
            try {
                return new Intl.NumberFormat("en-GB", { style: "currency", currency: currency }).format(pence / 100);
            } catch (e) {
                return "£" + (pence / 100).toFixed(2);
            }
        };

        var famCount = {},
            famImg = {},
            typeCount = {},
            colourSet = {},
            persSet = {};
        products.forEach(function (p) {
            if (p.family) {
                famCount[p.family] = (famCount[p.family] || 0) + 1;
                if (!famImg[p.family] && p.kind === "Cuddly plush" && p.image) famImg[p.family] = p.image;
            }
            typeCount[p.kind] = (typeCount[p.kind] || 0) + 1;
            p.colours.forEach(function (c) {
                colourSet[c] = 1;
            });
            p.personality.forEach(function (x) {
                persSet[x] = 1;
            });
        });
        var typeImg = {};
        products.forEach(function (p) {
            if (!typeImg[p.kind] && p.image) typeImg[p.kind] = p.image;
        });
        var PICK_TYPE = {
            "Cuddly plush": "katie-the-plush-long-leg-light-pink-bunny-35-cm-sof108",
            "Giant plushie": "talia-the-plush-cream-giant-bunny-sof171",
            "Baby comforter": "softies-baby-comforter-sunny-bunny-blue-two-side-short-plush-27cm-x-27cm-sof231",
            Keyring: "pip-the-plush-petrol-bear-keyring-sof146",
            "Water bottle": "leo-the-plush-lion-light-brown-stainless-steel-water-bottle-23cm-450ml-sof238",
        };
        var PICK_FAM = {
            "Bunny Bunch": "katie-the-plush-long-leg-light-pink-bunny-35-cm-sof108",
            "Bear Collective": "william-the-plush-sitting-brown-teddy-bear-22-cm-sof120",
            "Sea Softies": "wilfred-the-plush-dark-blue-whale-28-cm-sof133",
            "Dino Pals": "tommy-the-plush-green-dinosaur-30-cm-sof131",
            "Ele Friends": "ethel-the-plush-sitting-grey-elephant-22-cm-sof121",
            "Wild Ones": "freddie-the-plush-sitting-brown-fox-22-cm-sof122",
            "Fluffy Flock": "mary-the-plush-long-leg-mallard-chick-30cm-sof210",
            "Pawfect Pups": "coco-the-plush-long-leg-dark-brown-puppy-30cm-sof204",
        };
        products.forEach(function (p) {
            var h = (p.url || "").split("?")[0].split("/").pop();
            Object.keys(PICK_TYPE).forEach(function (k) {
                if (PICK_TYPE[k] === h && p.image) typeImg[k] = p.image;
            });
            Object.keys(PICK_FAM).forEach(function (k) {
                if (PICK_FAM[k] === h && p.image) famImg[k] = p.image;
            });
        });

        var families = FAMILIES.filter(function (f) {
            return famCount[f];
        });
        var colours = Object.keys(COLOURS).filter(function (c) {
            return colourSet[c];
        });
        var personalities = Object.keys(persSet).sort();
        var types = TYPES.filter(function (t) {
            return typeCount[t];
        });

        var state = { step: 0, shown: perPage, a: { who: "", types: [], families: [], colours: [], personality: [], budget: "" } };
        var steps = ["who", "types", "families", "colours", "personality", "budget"];

        function prog(n) {
            var h = '<div class="sq-prog" aria-hidden="true">';
            for (var i = 0; i < steps.length; i++) h += '<i class="' + (i < n ? "is-on" : "") + '"></i>';
            return h + '</div><p class="sq-qn">Question ' + n + " of " + steps.length + "</p>";
        }
        function pressed(on) {
            return ' aria-pressed="' + (on ? "true" : "false") + '"';
        }
        function nav(opts) {
            return '<div class="sq-nav">' + (opts.back ? '<button type="button" class="sq-link" data-act="back">Back</button>' : "") + (opts.skip ? '<button type="button" class="sq-link" data-act="skip">Skip</button>' : "") + '<button type="button" class="sq-btn" data-act="next">' + esc(opts.next || "Next") + '</button></div><p class="sq-error" role="alert"></p>';
        }

        function renderStep() {
            var a = state.a,
                k = steps[state.step],
                n = state.step + 1,
                h = prog(n),
                body = "";
            if (k === "who") {
                h += '<h2 class="sq-h2">Who\'s it for?</h2><p class="sq-sub">Pick one - we\'ll only show Softies that suit them.</p>';
                body =
                    '<div class="sq-opts">' +
                    WHO.map(function (w) {
                        return '<button type="button" class="sq-opt" data-k="who" data-v="' + w.v + '"' + pressed(a.who === w.v) + '><span class="sq-dot" style="background:' + w.c + '">' + w.icon + "</span><b>" + esc(w.label) + "</b><small>" + esc(w.sub) + "</small></button>";
                    }).join("") +
                    "</div>";
                h += body + nav({ next: "Next question" });
            } else if (k === "types") {
                h += '<h2 class="sq-h2">What kind of Softie?</h2><p class="sq-sub">Choose any that appeal.</p>';
                body =
                    '<div class="sq-opts">' +
                    types
                        .map(function (t) {
                            return '<button type="button" class="sq-opt" data-k="types" data-v="' + esc(t) + '"' + pressed(a.types.indexOf(t) > -1) + ">" + (typeImg[t] ? '<img class="sq-thumb" src="' + esc(typeImg[t]) + '" alt="" loading="lazy">' : "") + "<b>" + esc(t) + "</b><small>" + typeCount[t] + " Softies</small></button>";
                        })
                        .join("") +
                    '<button type="button" class="sq-opt" data-k="types" data-v="any"' +
                    pressed(a.types.indexOf("any") > -1) +
                    '><span class="sq-dot" style="background:#F6C8C8;width:96px;height:96px;font-family:SweetApricot,Georgia,serif;font-size:40px">?</span><b>Surprise me</b><small>Show me everything</small></button></div>';
                h += body + nav({ back: 1 });
            } else if (k === "families") {
                h += '<h2 class="sq-h2">Pick a family</h2><p class="sq-sub">Choose as many as you like, or skip.</p>';
                body =
                    '<div class="sq-opts sq-opts--4">' +
                    families
                        .map(function (f) {
                            return '<button type="button" class="sq-opt" data-k="families" data-v="' + esc(f) + '"' + pressed(a.families.indexOf(f) > -1) + ">" + (famImg[f] ? '<img class="sq-thumb" src="' + esc(famImg[f]) + '" alt="" loading="lazy">' : "") + "<b>" + esc(f) + "</b><small>" + famCount[f] + " Softies</small></button>";
                        })
                        .join("") +
                    "</div>";
                h += body + nav({ back: 1, skip: 1 });
            } else if (k === "colours") {
                h += '<h2 class="sq-h2">Favourite colour?</h2><p class="sq-sub">Pick any, or skip.</p>';
                body =
                    '<div class="sq-cols">' +
                    colours
                        .map(function (c) {
                            return '<button type="button" class="sq-col" data-k="colours" data-v="' + c + '"' + pressed(a.colours.indexOf(c) > -1) + '><span style="background:' + COLOURS[c] + '"></span>' + c.charAt(0).toUpperCase() + c.slice(1) + "</button>";
                        })
                        .join("") +
                    "</div>";
                h += body + nav({ back: 1, skip: 1 });
            } else if (k === "personality") {
                h += '<h2 class="sq-h2">What are they like?</h2><p class="sq-sub">Optional - pick up to three and we\'ll put the best matches first.</p>';
                body =
                    '<div class="sq-chips">' +
                    personalities
                        .map(function (x) {
                            return '<button type="button" class="sq-chip" data-k="personality" data-v="' + esc(x) + '"' + pressed(a.personality.indexOf(x) > -1) + ">" + esc(x) + "</button>";
                        })
                        .join("") +
                    "</div>";
                h += body + nav({ back: 1, skip: 1 });
            } else if (k === "budget") {
                h += '<h2 class="sq-h2">Any budget in mind?</h2><p class="sq-sub">Optional.</p>';
                body =
                    '<div class="sq-opts sq-opts--4">' +
                    BUDGETS.map(function (b) {
                        return '<button type="button" class="sq-opt" data-k="budget" data-v="' + b.v + '"' + pressed(a.budget === b.v) + "><b>" + esc(b.label) + "</b><small>" + esc(b.sub) + "</small></button>";
                    }).join("") +
                    "</div>";
                h += body + nav({ back: 1, skip: 1, next: "Show my Softies" });
            }
            stage.innerHTML = h;
        }

        function tagsFor(a) {
            var t = [];
            var w = WHO.filter(function (x) {
                return x.v === a.who;
            })[0];
            if (w) t.push(["who", "", w.label]);
            a.types.forEach(function (v) {
                if (v !== "any") t.push(["types", v, v]);
            });
            a.families.forEach(function (v) {
                t.push(["families", v, v]);
            });
            a.colours.forEach(function (v) {
                t.push(["colours", v, v.charAt(0).toUpperCase() + v.slice(1)]);
            });
            a.personality.forEach(function (v) {
                t.push(["personality", v, v]);
            });
            var b = BUDGETS.filter(function (x) {
                return x.v === a.budget;
            })[0];
            if (b) t.push(["budget", "", b.label]);
            return t;
        }

        function renderResults() {
            var res = match(products, state.a),
                total = res.length,
                best = res.length ? res[0].score : 0;
            var h = '<h2 class="sq-h2">Your perfect Softies</h2><p class="sq-sub">' + (total ? "We found " + total + " Softie" + (total === 1 ? "" : "s") + " that match your answers." : "No exact matches - try removing an answer below.") + "</p>";
            h +=
                '<div class="sq-tags">' +
                tagsFor(state.a)
                    .map(function (t) {
                        return '<button type="button" class="sq-tag" data-rm="' + t[0] + '" data-v="' + esc(t[1]) + '" aria-label="Remove ' + esc(t[2]) + '">' + esc(t[2]) + " ×</button>";
                    })
                    .join("") +
                '</div><button type="button" class="sq-link" data-act="restart">Start again</button>';
            if (total) {
                h +=
                    '<div class="sq-grid">' +
                    res
                        .slice(0, state.shown)
                        .map(function (r) {
                            var p = r.p,
                                badge = best > 0 && r.score === best ? "Best match" : "Great match";
                            var info = p.personality.slice(0, 2).join(" · ") || p.subtitle;
                            return '<div class="sq-pc"><a class="sq-pc__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : "") + '</a><div class="sq-pc__b"><span class="sq-badge">' + badge + '</span><a class="sq-pc__t" href="' + esc(p.url) + '">' + esc(p.title) + "</a><small>" + esc([p.family, info].filter(Boolean).join(" · ")) + '</small><div class="sq-row"><span class="sq-price">' + fmt(p.price) + '</span><button type="button" class="sq-btn sq-btn--sm" data-add="' + p.id + '">Add to bag</button></div></div></div>';
                        })
                        .join("") +
                    "</div>";
                if (total > state.shown) h += '<button type="button" class="sq-btn sq-btn--ghost" data-act="more">See all ' + total + " matches</button>";
            } else {
                h += '<div class="sq-empty">' + "<p class='sq-error'>Oh no! We couldn't find any Softies matching that exact combination.</p>" + '<button type="button" class="sq-btn" data-act="restart">Start again</button>' + "</div>";
            }
            h += '<div class="sq-club"><div><h3 class="sq-h3">Add free personalisation</h3><p>Join the Softies Club and stitch their name on their new best friend.</p></div><a class="sq-btn" href="' + esc(clubUrl) + '">Join the club</a></div>';
            stage.innerHTML = h;
        }

        function render(focus) {
            if (state.step >= steps.length) renderResults();
            else renderStep();
            if (focus) {
                stage.setAttribute("tabindex", "-1");
                stage.focus({ preventScroll: true });
                var top = root.querySelector(".sq-body").getBoundingClientRect().top + window.pageYOffset - 120;
                if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: "smooth" });
            }
        }

        function toggle(k, v) {
            var a = state.a;
            if (k === "who" || k === "budget") {
                a[k] = a[k] === v && k === "budget" ? "" : v;
            } else if (k === "types" && v === "any") {
                a.types = a.types.indexOf("any") > -1 ? [] : ["any"];
            } else {
                var arr = a[k].filter(function (x) {
                        return x !== "any";
                    }),
                    i = arr.indexOf(v);
                if (i > -1) arr.splice(i, 1);
                else {
                    if (k === "personality" && arr.length >= MAX_PERS) {
                        showError("You can pick up to three - untick one first.");
                        return;
                    }
                    arr.push(v);
                }
                a[k] = arr;
            }
            renderStep();
        }
        function showError(msg) {
            var e = stage.querySelector(".sq-error");
            if (e) e.textContent = msg;
        }

        stage.addEventListener("click", function (ev) {
            var el = ev.target.closest("button");
            if (!el || !stage.contains(el)) return;
            var k = el.getAttribute("data-k"),
                act = el.getAttribute("data-act");
            if (k) return toggle(k, el.getAttribute("data-v"));
            if (el.hasAttribute("data-rm")) {
                var f = el.getAttribute("data-rm"),
                    v = el.getAttribute("data-v");
                if (f === "who" || f === "budget") state.a[f] = "";
                else
                    state.a[f] = state.a[f].filter(function (x) {
                        return x !== v;
                    });
                state.shown = perPage;
                return renderResults();
            }
            if (el.hasAttribute("data-add")) return addToCart(el);
            if (act === "next") {
                var s = steps[state.step];
                if (s === "who" && !state.a.who) return showError("Please choose who it's for.");
                if (s === "types" && !state.a.types.length) return showError("Please choose at least one, or \"Surprise me\".");

                // Check if the current combination yields 0 results so far
                var currentMatches = match(products, state.a);
                if (currentMatches.length === 0) {
                    return showError("Oops! No Softies match this combination. Try changing your selection.");
                }

                state.step++;
                return render(true);
            }
            if (act === "skip") {
                var sk = steps[state.step];
                state.a[sk] = sk === "budget" ? "" : [];
                state.step++;
                return render(true);
            }
            if (act === "back") {
                state.step = Math.max(0, state.step - 1);
                return render(true);
            }
            if (act === "restart") {
                state.step = 0;
                state.shown = perPage;
                state.a = { who: "", types: [], families: [], colours: [], personality: [], budget: "" };
                return render(true);
            }
            if (act === "more") {
                state.shown = Infinity;
                return renderResults();
            }
        });

        function addToCart(btn) {
            var label = btn.textContent;
            btn.disabled = true;
            btn.textContent = "Adding…";
            var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
            var drawer = document.getElementById("cart-drawer");
            var opener = document.getElementById("cart-drawer-opener");
            var sections = drawer && typeof drawer.getSectionsToRender === "function" ? drawer.getSectionsToRender() : [];
            var body = { items: [{ id: Number(btn.getAttribute("data-add")), quantity: 1 }] };
            if (sections.length) {
                body.sections = sections
                    .map(function (s) {
                        return s.id;
                    })
                    .join(",");
                body.sections_url = window.location.pathname;
            }
            fetch(root_ + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify(body) })
                .then(function (r) {
                    return r.json().then(function (d) {
                        if (!r.ok || d.status) throw d;
                        return d;
                    });
                })
                .then(function (res) {
                    btn.textContent = "Added ✓";
                    if (res.sections) {
                        sections.forEach(function (s) {
                            var html = res.sections[s.id];
                            var target = document.getElementById(s.id);
                            if (!html || !target) return;
                            var src = new DOMParser().parseFromString(html, "text/html").querySelector(s.selector);
                            if (!src) return;
                            (target.querySelector(s.selector) || target).innerHTML = src.innerHTML;
                        });
                    }
                    var ci = document.querySelector("cart-items");
                    if (ci) {
                        ci.cartEmptyMessage = document.getElementById("cart-empty-message");
                        ci.cartForm = document.getElementById("cart");
                        ci.cartFooterContents = document.getElementById("cart-footer-contents");
                        try {
                            if (typeof ci.hideEmptyCart === "function") ci.hideEmptyCart();
                        } catch (e) {}
                    }
                    if (drawer && opener && typeof opener.openDrawer === "function") {
                        if (typeof drawer.setActiveElement === "function") drawer.setActiveElement(btn);
                        opener.openDrawer("cart-drawer");
                        if (typeof trapFocus === "function") trapFocus(drawer);
                    }
                    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") publish(PUB_SUB_EVENTS.cartUpdate, { source: "softies-quiz", cartData: res });
                    setTimeout(function () {
                        btn.disabled = false;
                        btn.textContent = label;
                    }, 2000);
                })
                .catch(function (err) {
                    console.warn("Softies quiz add to bag failed:", err);
                    btn.disabled = false;
                    btn.textContent = (err && err.description) || "Try again";
                });
        }

        render(false);
    }

    window.SoftiesQuiz = { match: match, prepare: prepare, productType: productType };
    function boot() {
        document.querySelectorAll("[data-softies-quiz]").forEach(function (r) {
            if (!r.__sq) {
                r.__sq = 1;
                init(r);
            }
        });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
    document.addEventListener("shopify:section:load", boot);
})();
